export default __webpack_public_path__ + "static/media/WORLD_LANGUAGES_SPANISH.157eab9f.svg";